import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TestimonialCard } from './TestimonialCard';
import { finalTestimonials } from '../data/salesData';
export function TestimonialsSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-210" data-mp="1n0tvoybdrhan">
      <div className="mx-auto max-w-6xl px-4" data-id="element-211" data-mp="1r1dvyar93110">
        <SectionHeading eyebrow="Comunidad" data-id="element-212" data-mp="1r02syd5mpxay">
          Lo que dicen quienes ya lo tienen
        </SectionHeading>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-213" data-mp="1d3xnyutb2z75">
          {finalTestimonials.map(t => <TestimonialCard key={t.name} testimonial={t} data-id="element-214" data-mp="1hyuv1w70yyhe" />)}
        </div>
      </div>
    </section>;
}